import { render, staticRenderFns } from "./CustomersDetailLink.vue?vue&type=template&id=9fe7f5c6"
import script from "./CustomersDetailLink.vue?vue&type=script&lang=js"
export * from "./CustomersDetailLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports